/**
 * Created by jv on 16/01/2017.
 */
var config = {
    serviceBaseURL: "/services",
    something: {}
};

if(__DEVELOPMENT__)
{
  config.something.something = "";
}
else
{
  config.something.something = "";
}

module.exports = config;



// WEBPACK FOOTER //
// ./app/js/config/config.js